//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';
//import EventEmitter from '../utils/emmiter';


import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default class Events extends React.Component {
  //static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {};
  };

  
  
  async componentDidMount() {
	}

	componentWillUnmount() {
	}


	

	render() {
		
		return (
			<>
				<div className="website-background"></div>
				<Container>
					<Row>
						<Col>Mix365 Radio Event</Col>
					</Row>
				</Container>
			</>
		);
	}
}
